<template>
  <div class="kefuList">
    <div class="chat-content" :style="$commonMethod.customAppHeader(1, 50)">
      <div class="chat-header">
        <div class="avatar">💬</div>
        <div class="info">
          <div class="info-title">Customer Support</div>
          <div class="info-subTitle">
            <span class="status-dot"></span>Online · 24/7 Available
          </div>
        </div>
      </div>
      <div class="chat-messages" id="messages">
        <div class="message-agent">
          <div class="bubble">
            Hello! 👋 Welcome to our customer support. How can I help you today?
          </div>
        </div>
        <div class="typing-indicator" id="typing">
          <span></span><span></span><span></span>
        </div>
      </div>
      <div class="chat-input">
        <input type="text" id="input" placeholder="Type your message..." autocomplete="off" />
        <button id="sendBtn">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <line x1="22" y1="2" x2="11" y2="13"></line>
            <polygon points="22 2 15 22 11 13 2 9 22 2"></polygon>
          </svg>
        </button>
      </div>
    </div>
  </div>
</template>
<script>
import kefuLanguage from "./kefuLanguage.js";
export default {
  name: "kefuList",
  data() {
    return {
      UserId: JSON.parse(localStorage.getItem("auth")).userInfo.UserId,
      CustomerId: JSON.parse(localStorage.getItem("auth")).userInfo.CustomerId,
      userData: JSON.parse(localStorage.getItem("auth")).userInfo,
      language: localStorage.getItem("requestLanguage") || "unknown",
      htmlData: null,
      htmlInput: null,
      isTyping: false,
    };
  },
  mounted() {
    this.setButtonEvent();
    this.handleLanguage();
  },
  methods: {
    setButtonEvent() {
      var action = () => {
        this.htmlInput = document.getElementsByClassName("chat-input")[0].children[0];
        if (this.htmlInput && this.htmlInput.value) {
          if (!this.isTyping) {
            this.applyMessage(this.htmlInput.value, "user");
            this.cozeChat(this.htmlInput.value);
          }
        }
      };
      document.getElementById("input").addEventListener("keyup", (event) => {
        if (event.key === "Enter") {
          action();
        }
      });
      document.getElementById("sendBtn").addEventListener("click", (event) => {
        action();
      });
    },
    cozeChat(message) {
      var systemSource = null;
      var customer_id = "";
      var customer_name = "";
      if (this.UserId) {
        customer_id = this.userData.UserNumber;
        customer_name = this.userData.UserName;
        systemSource = 1;
      }
      if (this.CustomerId) {
        customer_id = this.userData.CustomerNumber;
        customer_name = this.userData.CompanyName;
        systemSource = 2;
      }
      var param = {
        message: message,
        customer_id: customer_id,
        customer_name: customer_name,
        language: this.language,
        SystemSource: systemSource,
      };
      this.handleTyping(true);
      this.$api.kefu
        .cozeChat(param)
        .then((res) => {
          this.htmlInput.value = "";
          var data = JSON.parse(res.data);
          var reply = data.reply;
          this.applyMessage(reply, "agent");
          this.handleTyping(false);
        })
        .catch((err) => {
          this.handleTyping(false);
          this.$commonEnv.commonAction(this.$commonEnv.actionType.showNotify, {
            titleMsg: err.message,
            type: "danger",
          });
        });
    },
    applyMessage(text, type) {
      var messages = document.getElementsByClassName("chat-messages")[0];

      const outerDiv = document.createElement("div");
      outerDiv.className = "message-" + type;

      const innerDiv = document.createElement("div");
      innerDiv.className = "bubble";
      innerDiv.textContent = text;

      outerDiv.appendChild(innerDiv);
      messages.appendChild(outerDiv);
    },
    onClickLeft() {
      this.$commonEnv.commonAction(this.$commonEnv.actionType.pop);
    },
    handleTyping(isShow) {
      if (isShow) {
        this.isTyping = true;
        document.getElementById("input").disabled = true;
        var messages = document.getElementsByClassName("chat-messages")[0];

        var outerDiv = document.createElement("div");
        outerDiv.className = "typing-indicator";
        outerDiv.id = "typing";
        outerDiv.style.display = "block";

        var innerDiv1 = document.createElement("span");
        var innerDiv2 = document.createElement("span");
        var innerDiv3 = document.createElement("span");
        outerDiv.appendChild(innerDiv1);
        outerDiv.appendChild(innerDiv2);
        outerDiv.appendChild(innerDiv3);
        messages.appendChild(outerDiv);
      } else {
        this.isTyping = false;
        document.getElementById("input").disabled = false;
        var typings = document.getElementsByClassName("typing-indicator");
        if (typings && typings.length > 0) {
          for (var type of typings) {
            type.style.display = "none";
          }
        }
      }
    },
    handleLanguage() {
      var t = kefuLanguage[this.language];
      document.querySelector(".chat-header .info .info-title").textContent = t.title;
      document.querySelector(".chat-header .info .info-subTitle").innerHTML =
        '<span class="status-dot"></span>' + t.status;
      document.querySelector(".message-agent .bubble").textContent = t.welcome;
      document.getElementById("input").placeholder = t.inputPlaceholder;
    },
  },
};
</script>
<style lang="scss" scoped>
@import "~assets/scss/var";

.kefuList {
  .chat-content {
    position: absolute;
    left: 0;
    width: 100%;

    .chat-header {
      background: linear-gradient(135deg, #007bff, #0056b3);
      color: white;
      padding: 20px;
      display: flex;
      align-items: center;
      gap: 12px;
    }

    .chat-header .avatar {
      width: 44px;
      height: 44px;
      background: rgba(255, 255, 255, 0.2);
      border-radius: 50%;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 22px;
    }

    .chat-header .info-title {
      font-size: 16px;
      font-weight: 600;
      margin-bottom: 5px;
    }

    .chat-header .info-subTitle {
      font-size: 12px;
      opacity: 0.85;
      margin-top: 2px;

      ::v-deep .status-dot {
        width: 8px;
        height: 8px;
        background: #4caf50;
        border-radius: 50%;
        display: inline-block;
        margin-right: 4px;
        animation: pulse 2s infinite;
      }
    }

    .chat-messages {
      flex: 1;
      overflow-y: hidden;
      padding: 20px;
      background: transparent;
      margin-bottom: calc(77px + env(safe-area-inset-bottom));

      ::v-deep .message-agent {
        margin-bottom: 16px;
        display: flex;
        animation: fadeIn 0.3s ease;

        .bubble {
          background: #f8f9fa;
          color: #333;
          border-bottom-left-radius: 4px !important;
          box-shadow: 0 1px 3px rgba(0, 0, 0, 0.3);
          max-width: 75%;
          padding: 12px 16px;
          border-radius: 16px;
          font-size: 14px;
          line-height: 1.5;
          word-wrap: break-word;
        }
      }

      ::v-deep .message-user {
        margin-bottom: 16px;
        display: flex;
        animation: fadeIn 0.3s ease;
        justify-content: flex-end;

        .bubble {
          background: #007bff;
          color: white;
          border-bottom-right-radius: 4px !important;
          box-shadow: 0 1px 3px rgba(0, 0, 0, 0.3);
          max-width: 75%;
          padding: 12px 16px;
          border-radius: 16px;
          font-size: 14px;
          line-height: 1.5;
          word-wrap: break-word;
        }
      }

      ::v-deep .typing-indicator {
        display: none;
        padding: 12px 16px;
        background: #f8f9fa;
        border-radius: 16px;
        border-bottom-left-radius: 4px;
        box-shadow: 0 1px 3px rgba(0, 0, 0, 0.3);
        width: fit-content;

        span {
          display: inline-block;
          width: 8px;
          height: 8px;
          background: #999;
          border-radius: 50%;
          margin: 0 2px;
          animation: typing 1.4s infinite;
        }

        span:nth-child(2) {
          animation-delay: 0.2s;
        }

        span:nth-child(3) {
          animation-delay: 0.4s;
        }
      }
    }

    .chat-input {
      border-top: 1px solid #e0e0e0;
      display: flex;
      gap: 10px;
      background: white;
      box-sizing: border-box;
      position: fixed;
      left: 0;
      bottom: 0;
      width: 100%;
      z-index: 100;
      justify-content: space-between;
      padding-top: 16px;
      padding-left: 16px;
      padding-right: 16px;
      padding-bottom: calc(16px + env(safe-area-inset-bottom));
    }

    .chat-input input {
      flex: 1;
      padding: 12px 16px;
      border: 1px solid #ddd;
      border-radius: 24px;
      outline: none;
      font-size: 14px;
      transition: border-color 0.2s;
    }

    .chat-input input:focus {
      border-color: #007bff;
    }

    .chat-input button {
      width: 44px;
      height: 44px;
      background: #007bff;
      border: none;
      border-radius: 50%;
      color: white;
      cursor: pointer;
      display: flex;
      align-items: center;
      justify-content: center;
      transition: background 0.2s;
    }

    .chat-input button:disabled {
      background: #ccc;
      cursor: not-allowed;
    }

    .chat-input button svg {
      width: 20px;
      height: 20px;
    }

    @keyframes pulse {

      0%,
      100% {
        opacity: 1;
      }

      50% {
        opacity: 0.5;
      }
    }

    @keyframes fadeIn {
      from {
        opacity: 0;
        transform: translateY(8px);
      }

      to {
        opacity: 1;
        transform: translateY(0);
      }
    }

    @keyframes typing {

      0%,
      100% {
        transform: translateY(0);
      }

      50% {
        transform: translateY(-4px);
      }
    }

    @media (max-width: 520px) {
      body {
        background: white;
      }

      .chat-container {
        max-width: 100%;
        height: 100vh;
        max-height: none;
        border-radius: 0;
      }
    }
  }
}
</style>
